import { InternalAxiosRequestConfig } from "axios";
import { Utils } from "../../utils";
export const logInterReq = (request: InternalAxiosRequestConfig) => {
  //get type of request
  const method = request.method ?? "UNKNOWN";
  Utils.pushLog({
    tags: ["HTTP", method],
    message: request.url ?? "UNKNOWN",
    extraArgs: [{ requestData: request.data, requestHeaders: request.headers }],
    timeStamp: Date.now(),
  });
  return request;
};
